import { render } from "@/components/collections/templates/ThankyouTemplate.html?vue&type=template&id=fdf1a8b8&scoped=true"
import script from "./ExtendSubscriptionThankYouHeader.vue?vue&type=script&lang=js"
export * from "./ExtendSubscriptionThankYouHeader.vue?vue&type=script&lang=js"

import "@/assets/styles/components/modules/checkout/thankyou.styl?vue&type=style&index=0&id=fdf1a8b8&lang=stylus&scoped=true"

import exportComponent from "/runner/_work/cb-checkout/cb-checkout/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdf1a8b8"]])

export default __exports__